import axios from 'axios'

export interface SessionTokens {
  accessToken?: string | null
  refreshToken?: string | null
}

const LOGOUT_TIMEOUT_MS = 10000

function storedToken(key: string): string | null {
  const value = localStorage.getItem(key)
  return value && value !== 'undefined' && value !== 'null' ? value : null
}

export function readSessionTokens(): SessionTokens {
  return {
    accessToken: storedToken('accessToken'),
    refreshToken: storedToken('refreshToken'),
  }
}

export async function endServerSession(apiUrl: string | undefined, tokens: SessionTokens = {}) {
  const { accessToken, refreshToken } = tokens
  if (!apiUrl || (!accessToken && !refreshToken)) return
  try {
    await axios.post(
      `${apiUrl}/auth-keyklock/logout`,
      refreshToken ? { refreshToken } : {},
      {
        headers: accessToken ? { authorization: `Bearer ${accessToken}` } : undefined,
        timeout: LOGOUT_TIMEOUT_MS,
      },
    )
  } catch {
    // Os tokens já saíram do navegador; a sessão no servidor expira sozinha.
  }
}

export function replacedSession(previous: SessionTokens, nextAccessToken?: string | null): SessionTokens | null {
  if (!previous.accessToken && !previous.refreshToken) return null
  if (previous.accessToken && previous.accessToken === nextAccessToken) return null
  return previous
}
